import * as React from 'react';
import styled from 'styled-components';
import { strings } from '../localisation';
import { AlertOutline } from '../images/icons/AlertOutline';
import { Tooltip } from './Tooltip';
import { InformationCircle } from '@starryui10/images/icons/InformationCircle';
import { color } from '@starryui10/theme/color';

interface IInfoMessage {
    message: string;
    variant?: 'Information' | 'Alert';
}

export const InfoMessage = React.forwardRef<HTMLButtonElement, IInfoMessage>(({ message, variant = 'Alert' }, ref) => {
    const [active, setActive] = React.useState(false);

    const handleStateChange = (func: (value: React.SetStateAction<boolean>) => void, value: boolean) => {
        setActive(value);
        func(value);
    };

    return (
        <Tooltip caption={message}>
            {(visibleFunc) => (
                <Button
                    type="button"
                    onFocus={() => handleStateChange(visibleFunc, true)}
                    onBlur={() => handleStateChange(visibleFunc, false)}
                    onMouseEnter={() => handleStateChange(visibleFunc, true)}
                    onMouseLeave={() => handleStateChange(visibleFunc, false)}
                    aria-label={strings.Label_InfoMessage}
                    onClick={() => handleStateChange(visibleFunc, true)}
                    ref={ref}
                >
                    {variant === 'Alert' ? (
                        <AlertOutline color={active ? color.Blue.B60 : color.Green.G80} width="20px" height="20px" />
                    ) : (
                        <InformationCircle color={active ? color.Blue.B60 : color.Grey.G60} />
                    )}
                </Button>
            )}
        </Tooltip>
    );
});

const Button = styled.button`
    border-radius: 50%;
    height: 20px;
    width: 20px;
    border: 0;
    padding: 0;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
    background: transparent;

    > * {
        cursor: pointer !important;
    }
`;
